import type { UiKey } from "../i18n/ui";
import type { LlmPriceProfile } from "../lib/llmPriceProfile";

type Props = {
  t: (key: UiKey) => string;
  value: LlmPriceProfile;
  onChange: (p: LlmPriceProfile) => void;
};

const ORDER: LlmPriceProfile[] = ["economy", "standard", "premium"];
const LABEL: Record<LlmPriceProfile, UiKey> = {
  economy: "llmProfile.economy",
  standard: "llmProfile.standard",
  premium: "llmProfile.premium",
};

export function LlmProfilePanel({ t, value, onChange }: Props) {
  return (
    <div className="llm-profile">
      <h2>{t("llmProfile.title")}</h2>
      <p className="hint">{t("llmProfile.hint")}</p>
      <div className="tabs" role="tablist" aria-label={t("llmProfile.title")}>
        {ORDER.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={value === key}
            className={value === key ? "tab active" : "tab"}
            onClick={() => onChange(key)}
          >
            {t(LABEL[key])}
          </button>
        ))}
      </div>
      <style>{`
        .llm-profile h2 {
          font-size: 1rem;
          margin: 0 0 0.35rem;
        }
        .hint {
          margin: 0 0 0.65rem;
          font-size: 0.82rem;
          color: var(--muted);
          line-height: 1.45;
        }
        .tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        .tab {
          border: 1px solid var(--border);
          background: var(--surface2);
          color: var(--muted);
          padding: 0.35rem 0.75rem;
          border-radius: 8px;
          cursor: pointer;
          font: inherit;
          font-size: 0.88rem;
          font-weight: 600;
        }
        .tab.active {
          border-color: var(--accent-dim);
          color: var(--text);
          background: var(--accent-chip);
        }
        .tab:focus-visible {
          outline: 2px solid var(--accent);
          outline-offset: 2px;
        }
      `}</style>
    </div>
  );
}
